module.exports = __webpack_public_path__ + "img/icon-close.3ca1e9b3.svg";